import React from 'react';
import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import PropTypes from 'prop-types';
import { FDStack, FDTextButton } from '@facet-wealth/design';
import ActivationActionCard
  from './ActivationActionCard';

const MAX_ITEMS = 3;

const ActivationActions = ({ onActionClick, showAction }) => {
  const { relationshipCollection } = useIncludedRelationshipContext();
  const [showMore, setShowMore] = React.useState(false);
  const actionResources = relationshipCollection.resources().list();
  const alwaysShowingActionResources = actionResources.slice(0, MAX_ITEMS);
  const moreResources = actionResources.slice(MAX_ITEMS);
  const canShowMore = moreResources.length > 0;

  return (
    <FDStack direction={'column'} spacing={2} alignItems={'center'}>
      {alwaysShowingActionResources.map((actionResource) => {
        return (
          <ActivationActionCard
            key={actionResource.id()}
            resource={actionResource}
            onActionClick={showAction(actionResource) ? () => onActionClick(actionResource) : undefined}
          />
        );
      })}
      {showMore ? (
        moreResources.map((actionResource) => {
          return (
            <ActivationActionCard
              key={actionResource.id()}
              resource={actionResource}
              onActionClick={showAction(actionResource) ? () => onActionClick(actionResource) : undefined}
            />
          );
        })
      ) : null}
      {(canShowMore) ? (
        <FDTextButton
          label={(showMore) ? 'View Less' : 'View More'}
          icon={(showMore) ? 'keyboardArrowUp' : 'keyboardArrowDown'}
          onClick={() => {
            setShowMore((prev) => !prev);
          }}
        />
      ) : null}
    </FDStack>
  );
};

ActivationActions.propTypes = {
  onActionClick: PropTypes.func.isRequired,
  showAction: PropTypes.func.isRequired,
};

export default ActivationActions;
